import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Dialog,
  Button,
  TextField,
  Typography,
  IconButton,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import ModalNuevaGuia from "./ModalNuevaGuía";
import CloseIcon from "@mui/icons-material/Close";
import { RootStoreContext } from "../../app/store/root";
import { ErrorMessages } from "../../app/util/messages";

const initialState = {
  noGuium: undefined,
};
const ModalEscaneoGuia = ({ open, onClose }) => {
  const rootStore = useContext(RootStoreContext);
  const { getExistGuium } = rootStore.shipmentStore;

  /* UseState */
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [model, setModel] = useState(initialState);
  const [errors, setErrors] = useState({
    noGuium: false,
  });
  const [messages, setMessages] = useState({
    noGuium: undefined,
  });
  /* End UseState */

  useEffect(() => {
    if (!errors.noGuium && model?.noGuium) setDisabled(false);
    else setDisabled(true);
  }, [errors]);

  /* Methods */
  const setValue = (key, value) => {
    setModel({ ...model, ...{ [key]: value } });
  };
  const setError = (key, value) => {
    setErrors({ ...errors, ...{ [key]: value } });
  };
  const setMessage = (key, value) => {
    setMessages({ ...messages, ...{ [key]: value } });
  };
  const onCloseModalReceived = () => {
    setModel({ ...initialState });
    onClose();
  };
  /* End Methods */

  return (
    <Dialog
      open={open}
      onClose={() => onCloseModalReceived()}
      maxWidth={"md"}
      fullWidth={true}
    >
      <DialogTitle>
        No. de guía
        <IconButton
          aria-label="close"
          onClick={() => onCloseModalReceived()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Grid container direction={"column"} spacing={2}>
          <Grid item>
            <Typography variant="body1">
              Escanee o introduzca el No. de guía
            </Typography>
          </Grid>
          <Grid item>
            <TextField
              size="small"
              margin="normal"
              required
              fullWidth
              id="noGuia"
              label="Introduzca el no de guía."
              name="noGuia"
              error={errors.noGuium}
              onChange={(e) => {
                setValue("noGuium", e.target.value);
                setError(
                  "noGuium",
                  e.target.value.length <= 0 ||
                    e.target.value.length < 17 ||
                    e.target.value.length > 17
                );
                setMessage(
                  "noGuium",
                  e.target.value.length <= 0 ||
                    e.target.value.length < 17 ||
                    e.target.value.length > 17
                    ? ErrorMessages.envio.NoGuium
                    : ""
                );
              }}
              helperText={messages.noGuium}
              value={model.noGuium}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions variant="paddi">
        <Button
          variant="contained"
          color="secondary"
          sx={{ color: "#fff" }}
          onClick={() => onCloseModalReceived()}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          disabled={disabled}
          onClick={() => {
            getExistGuium(model.noGuium, false).then(
              (response) => {
                if (response) {
                  setOpenDialog(true);
                }
              },
              (err) => {}
            );
          }}
        >
          Aceptar
        </Button>
      </DialogActions>
      <ModalNuevaGuia
        open={openDialog}
        onClose={() => {
          setOpenDialog(!openDialog);
          onCloseModalReceived();
        }}
        isEdit={false}
        isReceive={true}
      />
    </Dialog>
  );
};

export default observer(ModalEscaneoGuia);
